import React from 'react';
import { Handle, Position } from 'reactflow';

const RequirementNode = ({ data }) => {
  return (
    <div className="group relative bg-white border-2 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-200 border-gray-300 w-[300px]">
      <Handle type="target" position={Position.Top} />
      <div className="bg-gray-900 text-white px-4 py-2 rounded-t-md font-semibold text-center">
        Requirement
      </div>
      <div className="p-4 space-y-3">
        <div className="p-2 bg-gray-50 border rounded-md">
          <h3 className="font-semibold text-gray-900 mb-2">{data.label}</h3>
          <p className="text-gray-700 text-sm">{data.description}</p>
        </div>
        {data.acceptance && (
          <div className="p-2 bg-gray-50 border rounded-md">
            <h4 className="font-semibold text-gray-800 mb-1">Acceptance Criteria</h4>
            <ul className="list-disc list-inside text-gray-600 text-sm">
              {data.acceptance.map((criterion, index) => (
                <li key={index}>{criterion}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default RequirementNode; 